// extracted by css-extract-rspack-plugin
export default {"mainSectionWrapper":"qm4Br","description":"S7rJ9","modalContainer":"_9UHU"};